exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{color:#fff;background:#fff}.index img{background:#fff;display:block}.index .notice{margin:20px auto;padding:15px 0;text-align:center;border:1px solid #000;border-width:1px 0;background:#666}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/styles/App.scss
// module id = 1089
// module chunks = 0